var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container_div",
      class: {
        show_mode: "show" == _vm.mode && _vm.hasVisibleFormType,
        "taojin-ticket-form-inline": false
      }
    },
    [
      _vm.ticketTaskFormData && _vm.ticketTaskFormData.length > 0
        ? [
            _vm.fullScreen || _vm.isNowFullScreen
              ? _c("div", { staticClass: "title_bar_1" }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "padding-left": "20px",
                        "font-weight": "600",
                        color: "#555"
                      }
                    },
                    [_vm._v("表单")]
                  ),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "el-icon-copy-document full-screen-btn",
                    attrs: { title: "最大化/还原 这个表单[13]" },
                    on: { click: _vm.doFullScreen }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "el-icon-minus form-minimize-btn",
                    attrs: { title: "最小化/还原 这个表单[19]" },
                    on: { click: _vm.do_minimize_form }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-form",
              {
                staticClass: "ticket_form",
                class: {
                  ticket_form_new: "new" == _vm.mode && !_vm.isNowFullScreen,
                  ticket_form_edit: "edit" == _vm.mode,
                  ticket_form_show: "show" == _vm.mode
                },
                attrs: { "label-width": "80px", "label-position": "top" }
              },
              [
                "edit" == _vm.mode && !_vm.hasVisibleFormType
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "font-size": "35px",
                          "padding-top": "45px",
                          color: "#EEE"
                        }
                      },
                      [_vm._v("没有需要填写的表单")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.ticketTaskFormData, function(e) {
                  return [
                    "allow_deny" == e.type
                      ? void 0
                      : _c(
                          "el-form-item",
                          {
                            key: e.id,
                            class: {
                              ticket_form_item: !_vm.isVertical(e),
                              ticket_form_item_vertical: _vm.isVertical(e),
                              ticket_form_item_new: "new" == _vm.mode,
                              ticket_form_item_divider: _vm.isDivider(e)
                            },
                            attrs: { title: e.name + " " + e.id }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                e.required && e.required == "true"
                                  ? _c("span", { staticClass: "required" }, [
                                      _vm._v("*")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(e.name))]),
                                _vm._v(" "),
                                "order" == e.type ||
                                "order_linkage" == e.type ||
                                "order_vertical" == e.type
                                  ? _c(
                                      "div",
                                      { staticStyle: { display: "inline" } },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              color: "#5b7e94",
                                              "font-size": "12px"
                                            },
                                            attrs: { title: "点我复制" },
                                            on: {
                                              click: function($event) {
                                                return _vm.copyOrder(e)
                                              }
                                            }
                                          },
                                          [_vm._v("复制")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              color: "#5b7e94",
                                              "font-size": "12px"
                                            },
                                            attrs: {
                                              title: "点击跳转到人员初筛页"
                                            },
                                            on: { click: _vm.goPeople }
                                          },
                                          [_vm._v("人员")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              color: "#5b7e94",
                                              "font-size": "12px"
                                            },
                                            attrs: {
                                              title: "点击跳转到培训计划页"
                                            },
                                            on: { click: _vm.goStudy }
                                          },
                                          [_vm._v("培训")]
                                        )
                                      ]
                                    )
                                  : "merchant_order_vertical_linkage" ==
                                      e.type ||
                                    "merchant_order_vertical" == e.type
                                  ? _c(
                                      "div",
                                      { staticStyle: { display: "inline" } },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              color: "#5b7e94",
                                              "font-size": "12px"
                                            },
                                            attrs: {
                                              title:
                                                "点我复制 商家 店铺 订单 信息"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.copyMerchantOrder(e)
                                              }
                                            }
                                          },
                                          [_vm._v("复制")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              color: "#5b7e94",
                                              "font-size": "12px"
                                            },
                                            attrs: {
                                              title: "点我复制 订单信息"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.copyMerchantOrder_order(
                                                  e
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("订单")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              color: "#5b7e94",
                                              "font-size": "12px"
                                            },
                                            attrs: {
                                              title: "点我复制 店铺信息"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.copyMerchantOrder_shop(
                                                  e
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("店铺")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              color: "#5b7e94",
                                              "font-size": "12px"
                                            },
                                            attrs: {
                                              title: "点我复制 商家信息"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.copyMerchantOrder_merchant(
                                                  e
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("商家")]
                                        )
                                      ]
                                    )
                                  : "merchant_linkage" == e.type ||
                                    "merchant" == e.type ||
                                    "merchant_vertical" == e.type
                                  ? _c(
                                      "div",
                                      { staticStyle: { display: "inline" } },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              color: "#5b7e94",
                                              "font-size": "12px"
                                            },
                                            attrs: { title: "点我复制" },
                                            on: {
                                              click: function($event) {
                                                return _vm.copyMerchant(e)
                                              }
                                            }
                                          },
                                          [_vm._v("复制")]
                                        )
                                      ]
                                    )
                                  : "shop" == e.type ||
                                    "shop_vertical" == e.type
                                  ? _c(
                                      "div",
                                      { staticStyle: { display: "inline" } },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              color: "#5b7e94",
                                              "font-size": "12px"
                                            },
                                            attrs: { title: "点我复制" },
                                            on: {
                                              click: function($event) {
                                                return _vm.copyShop(e)
                                              }
                                            }
                                          },
                                          [_vm._v("复制")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticStyle: { clear: "both" } }),
                            _vm._v(" "),
                            _c("TicketTaskFormItem", {
                              ref: "ticketTaskFormItem",
                              refInFor: true,
                              attrs: {
                                item: e,
                                fromDialog: _vm.fromDialog,
                                mode: _vm.mode
                              },
                              on: {
                                input: _vm.onInput_1,
                                change: _vm.onChange_1
                              },
                              model: {
                                value: _vm.properties,
                                callback: function($$v) {
                                  _vm.properties = $$v
                                },
                                expression: "properties"
                              }
                            })
                          ],
                          1
                        )
                  ]
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { clear: "both" } }),
            _vm._v(" "),
            "new" == _vm.mode && !_vm.hideSubmitButtom
              ? _c(
                  "div",
                  { staticStyle: { height: "50px", "margin-top": "20px" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { float: "right" },
                        attrs: {
                          title: "审批此工单,并提交相关表单[48]",
                          type: "primary"
                        },
                        on: { click: _vm.submitAssignToWorkflow }
                      },
                      [_vm._v("提交")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { float: "right", "margin-right": "10px" },
                        on: { click: _vm.onCancel }
                      },
                      [_vm._v("取消")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            "edit" == _vm.mode
              ? _c(
                  "div",
                  { staticStyle: { height: "50px", "margin-top": "20px" } },
                  [
                    !_vm.hasAllowDeny
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { float: "right" },
                            attrs: {
                              title: "审批此工单,并提交相关表单[57]",
                              type: "success"
                            },
                            on: { click: _vm.submit_1 }
                          },
                          [_vm._v("审批")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasAllowDeny
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { float: "right" },
                            attrs: {
                              title: "审批此工单,并提交相关表单[64]",
                              type: "danger"
                            },
                            on: { click: _vm.submitDeny }
                          },
                          [_vm._v("拒绝")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasAllowDeny
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { float: "right" },
                            attrs: {
                              title: "审批此工单,并提交相关表单[70]",
                              type: "primary"
                            },
                            on: { click: _vm.submitAllow }
                          },
                          [_vm._v("同意")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.ticketTaskFormData || _vm.ticketTaskFormData.length < 1
        ? [_vm._t("no_form")]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c0fee90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c0fee90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketTaskForm.vue
// module id = 712
// module chunks = 75